import { Component } from "../../../components/base/Component";
import { ICfa } from "../../../models/ICfa";
import { ComponentFactory } from "../../../services/ComponentFactory";
import { DataLayerService } from "../../services/DataLayerService";

// CFAC-42476
export class PositionSearchClick extends Component {
	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);

		_element.addEventListener("click", e => this.onContentClick(e));
	}

	async onContentClick(e: Event): Promise<void> {
		DataLayerService.pushDataLayerEvent_PositionSearchClick(this._element);
	}
}

ComponentFactory.registerComponent("positionSearchClick", PositionSearchClick);
